import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import SEO from '../../components/SEO/SEO'
import './NotFound.css'

function NotFound() {
  const { t } = useTranslation()
  const getLocalizedLink = useLocalizedLink()

  return (
    <div className="not-found-page">
      <SEO 
        title={t('notFound.title', 'Page Not Found')}
        description={t('notFound.description', 'The page you are looking for does not exist.')}
        noindex
      />
      <div className="container">
        <div className="not-found-content">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">
            {t('notFound.title', 'Page Not Found')}
          </h2>
          <p className="not-found-description">
            {t('notFound.description', 'The page you are looking for does not exist.')}
          </p>
          <Link to={getLocalizedLink('/')} className="btn btn-primary">
            {t('notFound.backHome', 'Back to Home')}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound

